import { useI18n } from '@change-corgi/core/react/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { rewardBandit } from 'src/app/shared/api/bandits';
import { convertToUsdString } from 'src/app/shared/utils/currency';

export function useComboBanditReward(): () => void {
	const utilityContext = useUtilityContext();
	const {
		data: {
			currency: { exchangeRate },
			comboBanditData,
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();
	const { amountToBaseUnits } = useI18n();

	return () => {
		if (comboBanditData?.experimentName && comboBanditData.variantName) {
			void rewardBandit(
				{
					experimentName: comboBanditData.experimentName,
					variantName: comboBanditData.variantName,
					increment: amountToBaseUnits(parseFloat(convertToUsdString(amount, exchangeRate)), 'usd'),
				},
				utilityContext,
				{ silent: true },
			);
		}
	};
}
